import { Button, ButtonsGroup, Card, Empty, Heading, Icon, PageHeader, Typo } from "#/atoms";
import { DESKTOP_SPACING, FONT_SIZE, NATURAL } from "@/theme";
import { FC, memo } from "react";
import { StyledCustomer, StyledCustomerName } from "./CustomerAndPackage.styled";

import { OrderCustomerAndPackagesProps } from "./CustomerAndPackage.interface";
import { PackageList } from "../PackageList";

const CustomerAndPackage: FC<OrderCustomerAndPackagesProps> = ({
  isAdmin,
  loadingOrderTemplates,
  onCreateCustomer,
  onFindCustomer,
  onRemoveCustomer,
  onSelectOrderTemplate,
  onShowMore,
  orderTemplates,
  selectedCustomer,
}) => {
  return (
    <>
      {isAdmin && (
        <>
          <PageHeader>
            <Heading scale="h1" fontColor={NATURAL.K}>Select Customer</Heading>
          </PageHeader>
          <Card>
            {selectedCustomer ? (
                <StyledCustomer key={selectedCustomer.id}>
                  <StyledCustomerName>Customer: <strong>{selectedCustomer.firstName} {selectedCustomer.lastName}</strong></StyledCustomerName>
                  <Button actionType="icon" onClick={onRemoveCustomer}><Icon type="cross" /></Button>
                </StyledCustomer>
            ) : (
              <Empty>No customer have been added yet.</Empty>
            )}
            <ButtonsGroup fullWidth>
              <Button actionType='outline' onClick={onCreateCustomer}>Create Customer</Button>
              <Button onClick={onFindCustomer}>Find Customer</Button>
            </ButtonsGroup>
          </Card>
        </>
      )}
      <PageHeader>
        <Heading scale="h1" fontColor={NATURAL.K} margin={`0 0 ${DESKTOP_SPACING.SM}px`}>Select Package</Heading>
        <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>Please select appropriate package of services for your new order.</Typo>
      </PageHeader>
      <PackageList
        isAdmin={isAdmin}
        loadingOrderTemplates={loadingOrderTemplates}
        onSelectOrderTemplate={onSelectOrderTemplate}
        orderTemplates={orderTemplates} />
    </>
  );
}

export default memo(CustomerAndPackage);
